
export default class CollectionTransformer {
    transform(transformer, data = []) {
        let result = [];

        if (Array.isArray(data)) {
            data.map((elem) => {
                result.push(transformer.transform(elem))
            })
        }

        return result;
    }
}
